// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"2b7a3836","142":"04c93f7a","150":"7b1f450d","185":"07dc3438","210":"d08ddc8e","314":"66dd3fac","389":"56470f39","528":"dc0d0be0","571":"5a337b3e","912":"56470f39","954":"bcf58084"}[chunkId] + ".chunk.css";
};